import Icons, { IIconsProps } from '@shared/components/core/images/Icons';
import { BodySmall, TitleSmall } from '@shared/components/core/text/Typography';
import { ICoreCardProps } from '@shared/models/components/ICoreCardProps';
import { CardSmall, IconWrap, WrapCardText } from './CommonCardStyles';

interface ICardIconProps extends IIconsProps, ICoreCardProps {}

const CardIcon: React.FC<ICardIconProps> = ({ title, description, name, size = 100, children, ...restProps }) => {
    return (
        <CardSmall>
            <IconWrap>
                <Icons name={name} size={size} {...restProps} />
            </IconWrap>
            <WrapCardText>
                <TitleSmall>{title}</TitleSmall>
                <BodySmall>{description}</BodySmall>
                {children}
            </WrapCardText>
        </CardSmall>
    );
};

export default CardIcon;
